module.exports = __webpack_public_path__ + "img/consult.bb624750.svg";